import { clsx } from "clsx";
import {
  type CSSProperties,
  forwardRef,
  type ForwardRefRenderFunction,
  type HTMLAttributes,
  type PropsWithChildren,
} from "react";

import { useDataAttributes } from "../../hooks/useDataAttributes.ts";
import style from "./Stack.module.css";

export interface VStackProps {
  /** @default 5px */
  spacing?: number;
  /** @default false */
  wrap?: boolean;
  className?: string;
  style?: CSSProperties;
  domProps?: HTMLAttributes<HTMLDivElement>;
}

const VStackRender: ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren<VStackProps>> = (props, ref) => {
  const dataAttributes = useDataAttributes(props);

  return (
    <div
      {...props.domProps}
      data-testid="v-stack"
      {...dataAttributes}
      ref={ref}
      className={clsx(style.v_stack, props.className)}
      style={{
        gap: props.spacing != undefined ? `${props.spacing}px` : undefined,
        flexWrap: props.wrap ? "wrap" : undefined,
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};

export const VStack = forwardRef(VStackRender);
